import { AppWindow, Shield, Tags, UserCircle, UsersRound } from "lucide-react"
import * as React from "react"

export type AccountNavItem = {
  title: string
  url: string
  icon: React.ComponentType<{ className?: string }>
}

const accountUrl = process.env.NEXT_PUBLIC_ACCOUNT_APP_URL

export const accountNavItems: AccountNavItem[] = [
  { title: "My Profile", url: `${accountUrl}/account`, icon: UserCircle },
  { title: "My Apps", url: `${accountUrl}/account/apps`, icon: AppWindow },
  { title: "My groups", url: `${accountUrl}/account/groups`, icon: UsersRound },
  { title: "My Interests", url: `${accountUrl}/account/interests`, icon: Tags },
  {
    title: "Privacy & Consent",
    url: `${accountUrl}/account/privacy`,
    icon: Shield,
  },
]
